import React, { ReactNode } from "react";
import classNames from "classnames";
import { Check } from "react-bootstrap-icons";
import { Step } from "./step";

import styles from "./stepper.module.scss";
interface stepperProps {
  className?: string;
  activeKey: number;
  children: ReactNode;
  inProgress: boolean;
}
const Stepper: React.FC<stepperProps> = ({
  className,
  inProgress,
  children,
  activeKey,
}) => {
  const stepsClass = (key: number, activeKey: number) => {
    if (inProgress && key === activeKey) {
      return styles.active;
    } else if (activeKey < key) {
      return styles.disable;
    } else if (activeKey >= key) {
      return styles.passed;
    }
  };
  const stepperContainerClass = classNames(styles.stepper_container, className);
  return (
    <div className={stepperContainerClass}>
      <div className={styles.stepper_header}>
        {React.Children.map(children, (child, index) => {
          if (child && React.isValidElement(child)) {
            const { step, title, description, stepKey } = child.props;
            return (
              <button
                className={styles.steps_header_container}
                key={index}
                disabled={!(activeKey === stepKey)}
              >
                <div
                  className={`${styles.steps_header} ${stepsClass(
                    stepKey,
                    activeKey
                  )}`}
                >
                  <div className={styles.steps_circle}>
                    {activeKey >= stepKey && (
                      <Check color="white" size={"40px"} />
                    )}
                  </div>
                  {React.Children.count(children) - 1 !== index && (
                    <div className={styles.steps_connector}></div>
                  )}
                </div>
                <div className={stepsClass(stepKey, activeKey)}>
                  <div className={styles.step_title}>
                    <div>{step}</div>
                    <div>{title}</div>
                    <div>{description}</div>
                  </div>
                </div>
              </button>
            );
          }
        })}
      </div>
      <div>
        {React.Children.map(children, (child) => {
          if (child && React.isValidElement(child)) {
            const { stepKey } = child.props;
            if (stepKey === activeKey) return child;
          }
        })}
      </div>
    </div>
  );
};
export { Stepper, Step };
